import { api } from '@api';
import { ToyHistoryItemLoader } from './ToyHistoryItemLoader';
import { useGetArtist } from '@hooks/TRPC_Hooks/useGetArtist';
import { useTranslation } from '@hooks/useTranslation';
import { FC } from 'react';
import s from './toyHistoryItem.module.scss';
import moment from 'moment';
import cn from 'classnames';
import { ArtistAvatar } from '@components/UIKit/ArtistAvatar/ArtistAvatar';
interface ToyHistoryArtistItemProps {
  artistId: number;
  toyId: number;
}
export const ToyHistoryArtistItem: FC<ToyHistoryArtistItemProps> = ({
  artistId,
  toyId
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    data: artist,
    isLoading: artistLoading
  } = useGetArtist({
    id: artistId
  });
  const {
    data: dropDate,
    isLoading: dropDateLoading
  } = api.ToyManager.getDropDate.useQuery({
    toyId
  }, {
    queryKey: ['ToyManager.getDropDate', {
      toyId
    }],
    refetchOnWindowFocus: false,
    staleTime: 24 * 60 * 60 * 1000 // 1 day
  });
  const isLoading = artistLoading || dropDateLoading;
  if (isLoading) return <ToyHistoryItemLoader />;
  if (!artist) return null;
  const {
    name,
    profile
  } = artist;
  const date = dropDate ? moment(dropDate?.start).format('DD.MM.YYYY') : '-';
  const time = dropDate ? moment(dropDate?.start).format('HH:mm') : '-';
  return <div className={s.toyHistoryItem} data-sentry-component="ToyHistoryArtistItem" data-sentry-source-file="ToyHistoryArtistItem.tsx">
            <div className={s.toyHistoryItem__body}>
                <ArtistAvatar shortId={profile?.shortid ?? ''} srcSet={[{
        height: 40,
        width: 40,
        minMedia: 0
      }]} data-sentry-element="ArtistAvatar" data-sentry-source-file="ToyHistoryArtistItem.tsx" />
                <div className={s.toyHistoryItem__main}>
                    <div className={cn(s.toyHistoryItem__name, '_ellipsis')}>
                        {profile?.shortid ?? name}
                    </div>
                    {dropDate && <div className={s.toyHistoryItem__date}>
                            {tr({
            id: 'toy.page.history.date.text'
          }, {
            date,
            time
          })}
                        </div>}
                </div>
                <div className={s.toyHistoryItem__right}>{tr({
          id: 'toy.page.created'
        })}</div>
            </div>
        </div>;
};